
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta } from "/app/app/pages/login.vue?macro=true";
import { default as trackjcZU9rou_An0bNynUbplCcXl2u68vVWE1avzdqNw3mUMeta } from "/app/app/pages/track.vue?macro=true";
import { default as registerhPH0MU2Juf_wsbIztPgIOhf1JmD4z1RPu17er_DhMMAMeta } from "/app/app/pages/register.vue?macro=true";
import { default as settingsTWvHjpVkfjKsEMAblILOtSL39Q1Q7p_32B16g4gh6MIMeta } from "/app/app/pages/settings.vue?macro=true";
import { default as _91id_932h_KU5vcziBxsMtxBzd6U4KmKHrDiw_uwozPsGoinP4Meta } from "/app/app/pages/menus/[id].vue?macro=true";
import { default as indexZiJJO9Kfx81_vFYRFbgVGmGSZ5F8pxcxdwd0CrSnRL4Meta } from "/app/app/pages/menus/index.vue?macro=true";
import { default as _91id_93fTG2Olw2snAjVyGaGP5zVodpeHSvKAUgn54u5sEL_bMMeta } from "/app/app/pages/orders/[id].vue?macro=true";
import { default as indexaBoaaCbF6nn57boy_A7hFQ3LYrZLZKvvNObCQ61fmrsMeta } from "/app/app/pages/repas/index.vue?macro=true";
import { default as indexLdNUQ4MIhBpg7fAzfpvdMU7gu9Bg6nib_8MieNFMpMUMeta } from "/app/app/pages/profile/index.vue?macro=true";
import { default as validate_45userNeBwGBxcAp5qhsU_cGKQmNLr5E2CnYKvMGqzdeN47CEMeta } from "/app/app/pages/validate-user.vue?macro=true";
import { default as index1b_jt3UwwuhOkl2OiTOKFr7zPTc8rYoi2CXRi3JLcBgMeta } from "/app/app/pages/boissons/index.vue?macro=true";
import { default as indextuxD9i30ur3bawJlePRY341J_J7eXdwpjTspY2246F0Meta } from "/app/app/pages/checkout/index.vue?macro=true";
import { default as indexCR__Tt7GBeXAq7tirfVxmqe2__h_GM4HTfuEGQPVpzoMeta } from "/app/app/pages/desserts/index.vue?macro=true";
import { default as _91id_93fMwEC9RSMubErWD2_Dwx55rkd4uVFKNVeTlwILSDkAwMeta } from "/app/app/pages/menus/menu/[id].vue?macro=true";
import { default as _91id_93SYBNTvW4WVd91CU2fdF39yCx_3s_3R4Z7Z7X_NfwClYMeta } from "/app/app/pages/repas/repa/[id].vue?macro=true";
import { default as success5nC_JyN2xX9_5oWIKoC9kwncp0Vsc4SiapJkNl6wAb4Meta } from "/app/app/pages/checkout/success.vue?macro=true";
import { default as _91category_93aOpt8AGoZbfK_Npjf05apsXFimag_Ogc0HyVpdIacz4Meta } from "/app/app/pages/repas/[category].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "track",
    path: "/track",
    component: () => import("/app/app/pages/track.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: {"middleware":"auth"},
    component: () => import("/app/app/pages/register.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/app/app/pages/settings.vue")
  },
  {
    name: "menus-id",
    path: "/menus/:id()",
    component: () => import("/app/app/pages/menus/[id].vue")
  },
  {
    name: "menus",
    path: "/menus",
    component: () => import("/app/app/pages/menus/index.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: () => import("/app/app/pages/orders/[id].vue")
  },
  {
    name: "repas",
    path: "/repas",
    component: () => import("/app/app/pages/repas/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/app/pages/profile/index.vue")
  },
  {
    name: "validate-user",
    path: "/validate-user",
    component: () => import("/app/app/pages/validate-user.vue")
  },
  {
    name: "boissons",
    path: "/boissons",
    component: () => import("/app/app/pages/boissons/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/app/app/pages/checkout/index.vue")
  },
  {
    name: "desserts",
    path: "/desserts",
    component: () => import("/app/app/pages/desserts/index.vue")
  },
  {
    name: "menus-menu-id",
    path: "/menus/menu/:id()",
    component: () => import("/app/app/pages/menus/menu/[id].vue")
  },
  {
    name: "repas-repa-id",
    path: "/repas/repa/:id()",
    component: () => import("/app/app/pages/repas/repa/[id].vue")
  },
  {
    name: "checkout-success",
    path: "/checkout/success",
    component: () => import("/app/app/pages/checkout/success.vue")
  },
  {
    name: "repas-category",
    path: "/repas/:category()",
    component: () => import("/app/app/pages/repas/[category].vue")
  }
]